import { useAccountStoreActions, useAccountStoreGetters } from "@Client/@Modules/main/store/account/account-helpers";
import AppSidebar from "@Client/@Modules/utils-components/widgets/app-sidebar.vue";
import { defineComponent, onMounted, ref, computed } from "@vue/composition-api";
import * as AccountActions from "../store/account/account-actions";
import * as AccountGetters from "../store/account/account-getters";
import { useRoute } from "@Shared/@Composables/route/useRoute";
export default defineComponent({
  name: "ApplicationSidebarLayout",
  components: {
    AppSidebar
  },
  setup() {
    const loading = ref(true);
    const {
      LOAD_AGENT_ACCOUNT_DETAILS
    } = useAccountStoreActions([AccountActions.LOAD_AGENT_ACCOUNT_DETAILS]);
    const {
      AGENT_ACCOUNT_DETAILS
    } = useAccountStoreGetters([AccountGetters.AGENT_ACCOUNT_DETAILS]);
    const showSidebar = computed(() => {
      var _useRoute$query, _useRoute$query2;
      return ((_useRoute$query = useRoute().query) == null ? void 0 : _useRoute$query.sidebar) && ((_useRoute$query2 = useRoute().query) == null ? void 0 : _useRoute$query2.sidebar) === "true";
    });
    onMounted(async () => {
      loading.value = true;
      await LOAD_AGENT_ACCOUNT_DETAILS({
        hardReload: true
      });
      loading.value = false;
    });
    return {
      AGENT_ACCOUNT_DETAILS,
      loading,
      showSidebar
    };
  }
});